function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpecialty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 48,
    viewBox: "0 0 86 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M54.3388 4.91241H32.3988L21.4288 23.9124L32.3988 42.9124H54.3388L65.3087 23.9124L54.3388 4.91241Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5087 39.2558L25.6486 23.9124L34.5087 8.56911H52.2252L61.0853 23.9124L52.2252 39.2558H34.5087Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3388 4.91241H32.3988L21.4288 23.9124L32.3988 42.9124H54.3388L65.3087 23.9124L54.3388 4.91241Z",
    stroke: "#1D1D1B",
    style: {
      stroke: "#1D1D1B",
      stroke: "color(display-p3 0.1137 0.1137 0.1059)",
      strokeOpacity: 1
    },
    strokeWidth: 1.42598,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5087 39.2558L25.6486 23.9124L34.5087 8.56911H52.2252L61.0853 23.9124L52.2252 39.2558H34.5087Z",
    stroke: "#1D1D1B",
    style: {
      stroke: "#1D1D1B",
      stroke: "color(display-p3 0.1137 0.1137 0.1059)",
      strokeOpacity: 1
    },
    strokeWidth: 1.42598,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecialty);
export default __webpack_public_path__ + "static/media/Specialty.3a5c8e9166ebcc8b8e4de101fc911767.svg";
export { ForwardRef as ReactComponent };